import { getCountry } from 'src/utils/urls';
import { CountryObj } from 'src/types/countryType';

type APIResult = {
  Data : Array<CountryObj>;
  isSuccess: boolean;
  statusCode: number;
}

export async function fetchCountryDetails({
  token,
  tokenType,
}: Partial<{
  token: string;
  tokenType: string;
}>): Promise<APIResult> {
  const response = await fetch(getCountry, {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
  });
  return response.json();
}
